import { Fragment } from 'react';

import { Divider } from '@hivebrite/design-system/Divider';

import { PADDING_INPUT_SET_TYPES } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode/ButtonStyle/constants/paddings';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

import ButtonStyle from './ButtonStyle';
import Typography from './Typography';

const CustomMode = ({ item, settingProps }) => {
  const buttons = (item.children || [
    item,
  ]) as DocumentItem<ButtonItemAttributes>[];
  const numberButtons = buttons.length;

  return buttons.map((button, index) => (
    <Fragment key={`settingButton-${button.id}`}>
      {index > 0 && <Divider mb={5} mt={2} />}
      {numberButtons > 1 && (
        <InputTitle
          boxProps={{ mb: 3 }}
          label={s__('Builder|Button %{index}').i__({
            index: (index + 1).toString(),
          })}
          position="top"
        />
      )}
      <Typography
        {...settingProps}
        item={button}
        numberButtons={numberButtons}
      />
      <ButtonStyle
        {...settingProps}
        item={button}
        showColorOnlyForBorders={numberButtons > 1}
        displayedPaddingInputs={
          numberButtons > 1
            ? PADDING_INPUT_SET_TYPES.HORIZONTAL
            : PADDING_INPUT_SET_TYPES.ALL
        }
      />
    </Fragment>
  ));
};

export default CustomMode;
